"use client";

import React, { useRef } from "react";
import {
  generateStringId,
  getDomainFromURL,
  sortProjectsByDate,
} from "@/app/shared/utils/utils";
import { projects } from "@/app/data/projectData";
import Link from "next/link";
import { MdOutlineArrowOutward } from "react-icons/md";
import PageWrapper from "../PageWrapper/PageWrapper";
import TopSection from "../../shared/components/TopSection/TopSection";
import BackwardsArrowLink from "@/app/shared/components/BackwardsArrowLink/BackwardsArrowLink";

const Archive: React.FC = () => {
  const projectList = sortProjectsByDate(projects);

  const contentRef = useRef<HTMLTableElement>(null);

  // const handleScrollToContent = () => {
  //   console.log("element: ", contentRef.current);
  //   if (contentRef.current) {
  //     console.log("has current");
  //     contentRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // };

  return (
    <PageWrapper>
      <TopSection />
      <div className="mx-auto min-h-screen max-w-screen-xl px-6 py-12 md:px-12 md:py-20 lg:px-24 lg:py-0">
        {/* <a
          onClick={handleScrollToContent}
          rel="noreferrer"
          role="button"
          className="absolute left-0 top-0 block rounded bg-gradient-to-br from-blue-400 via-blue-500 to-purple-600 px-4 py-3 text-sm font-bold uppercase tracking-widest text-white focus-visible:translate-x-0 cursor-pointer"
        >
          Skip to content
        </a> */}
        <div className="lg:py-24">
          <BackwardsArrowLink href="/" text="Martin Beck Andersen" />
          <h1 className="text-4xl font-bold tracking-tight text-slate-200 sm:text-5xl">
            All Projects
          </h1>
          <table
            ref={contentRef}
            id="content"
            className="mt-12 w-full border-collapse text-left"
          >
            <thead className="sticky top-0 z-10 border-b border-slate-300/10 px-6 py-5 backdrop-blur">
              <tr>
                <th className="py-4 pr-8 text-sm font-semibold text-slate-200">
                  Year
                </th>
                <th className="py-4 pr-8 text-sm font-semibold text-slate-200">
                  Project
                </th>
                <th className="hidden py-4 pr-8 text-sm font-semibold text-slate-200 lg:table-cell">
                  Made at
                </th>
                <th className="hidden py-4 pr-8 text-sm font-semibold text-slate-200 lg:table-cell">
                  Built with
                </th>
                <th className="hidden py-4 pr-8 text-sm font-semibold text-slate-200 lg:table-cell">
                  Link
                </th>
              </tr>
            </thead>
            <tbody>
              {projectList.map((project) => (
                <tr
                  className="border-b border-slate-300/10 last:border-none"
                  key={project.id}
                >
                  <td className="py-4 pr-4 align-top text-sm">
                    <div className="translate-y-px">{project.year}</div>
                  </td>
                  <td className="py-4 pr-4 align-top font-semibold leading-snug text-slate-200">
                    <div>
                      <div className="block sm:hidden">
                        <Link
                          href={`${project.link ? project.link : ""}`}
                          target="_blank"
                          rel="noreferrer"
                          className={`inline-flex items-baseline text-sm font-medium leading-tight hover:text-blue-300 focus-visible:text-blue-300  group/link ${
                            project.link
                              ? "cursor-pointer"
                              : "cursor-auto pointer-events-none"
                          }`}
                          aria-label={
                            project.link
                              ? getDomainFromURL(project.link)
                              : project.name
                          }
                        >
                          <span>
                            <span className="inline-block">
                              {project.name}
                              {project.link && (
                                <MdOutlineArrowOutward className="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-1 translate-y-px" />
                              )}
                            </span>
                          </span>
                        </Link>
                      </div>
                      <div className="hidden sm:block">{project.name}</div>
                    </div>
                  </td>
                  <td className="hidden py-4 pr-4 align-top text-sm lg:table-cell">
                    <div className="translate-y-px whitespace-nowrap">
                      {project.createdAt}
                    </div>
                  </td>
                  <td className="hidden py-4 pr-4 align-top lg:table-cell">
                    <ul className="flex -translate-y-1.5 flex-wrap">
                      {project.skills.map((skill) => (
                        <li className="my-1 mr-1.5" key={generateStringId()}>
                          <div className="flex items-center rounded-full bg-blue-400/10 px-3 py-1 text-xs font-medium leading-5 text-blue-300">
                            {skill}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td className="hidden py-4 align-top sm:table-cell">
                    <ul className="translate-y-1">
                      <li className="mb-1 flex items-center">
                        {project.link && (
                          <Link
                            href={project.link}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-baseline text-sm font-medium leading-tight hover:text-blue-300 focus-visible:text-blue-300  group/link"
                            aria-label={getDomainFromURL(project.link)}
                          >
                            <span>
                              <span className="inline-block">
                                {getDomainFromURL(project.link)}
                                <MdOutlineArrowOutward className="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-0.5" />
                              </span>
                            </span>
                          </Link>
                        )}
                      </li>
                    </ul>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Archive;
